"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _PluggableElementBase2 = _interopRequireDefault(require("./PluggableElementBase"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var WidgetType = /*#__PURE__*/function (_PluggableElementBase) {
  (0, _inherits2.default)(WidgetType, _PluggableElementBase);

  var _super = _createSuper(WidgetType);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function WidgetType(stuff) {
    var _this;

    (0, _classCallCheck2.default)(this, WidgetType);
    _this = _super.call(this, stuff);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "heading", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "configSchema", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "HeadingComponent", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "ReactComponent", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "stateModel", void 0);
    _this.heading = stuff.heading;
    _this.HeadingComponent = stuff.HeadingComponent;
    _this.configSchema = stuff.configSchema;
    _this.stateModel = stuff.stateModel;
    _this.ReactComponent = stuff.ReactComponent;

    if (!_this.ReactComponent) {
      throw new Error("no ReactComponent defined for widget ".concat(_this.name));
    }

    if (!_this.stateModel) {
      throw new Error("no stateModel defined for widget ".concat(_this.name));
    }

    return _this;
  }

  return WidgetType;
}(_PluggableElementBase2.default);

exports.default = WidgetType;